import { type PropsWithChildren } from 'react'

import { Box, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import Subtitle from './Subtitle'

interface Props {
  title: string
  tooltip?: string
}

function Header({ title, tooltip, children }: PropsWithChildren<Props>) {
  const [open, toggle] = useToggle(false)

  return (
    <Box flexDirection="column">
      <Box gap="s12" flexDirection="row" alignItems="center">
        <Text.Header1 color="grey1000">{title}</Text.Header1>
        {tooltip && (
          <Tooltip.Alt open={open} toggle={toggle} attachment="top center" label={tooltip}>
            <Icon.Small icon="info" encircled="grey800" />
          </Tooltip.Alt>
        )}
      </Box>
      <Box flexDirection="row" gap="s64" paddingTop="s24">
        {children}
      </Box>
    </Box>
  )
}

Header.Subtitle = Subtitle

export default Header
